import { graphql } from 'gatsby';
import { RegionExplorerLayout } from '../../components/entities/region-explorer-layout';
import { createGatsbyPageComponent } from '@shapeable/ui';
export default createGatsbyPageComponent('Region', { layout: RegionExplorerLayout });

export const query = graphql`
query RegionQuery($id: ID!) {
  platform { region(id: $id) {
    id slug path name typeLabel __typename _schema { label pluralLabel }
    banner {
      id name slug title description { text } alternateText
      image { id url url2x width height thumbnails { card { url url2x } bubble { url url2x } } }
    }
    latitude longitude
    populationNearKelp
    coastlineLengthkm
    gdpWithin50kmKelp
    oceanWarmingRate
    kelpAreaHectares
    zoomLevel
    keyMessageImage {
      openGraph {
        id image { url url2x thumbnails { bubble { url url2x } } }
      }
    }
    description {
      id
      text
    }
    authors {
      id slug name __typename
      openGraph {
        id image { url url2x thumbnails { bubble { url url2x } } }
      }
    }
    organisations { 
      id slug path name __typename _schema { label pluralLabel }
      openGraph {
        id image { url url2x thumbnails { bubble { url url2x } } }
      }
    }
    places {
      __typename id slug name
      latitude longitude
      openGraph {
        id
        image {
          id
          url url2x
        }
      }
    }
    species {
      __typename id slug path name
      openGraph {
        id title description {
          id text
        }
        image {
          url url2x
        }
      }
    }
    restorationProjects {
      __typename id name path slug
      place {
        name
      }
      openGraph {
        id title description { id text }
        image {
          id url url2x
        }
      }
      species {
        id name path
        openGraph {
          id
          title
          description { id text }
        }
      }
      methodologies {
        id name path
        openGraph {
          id 
          title
          description {id text}
        }
      }
    }
    indicatorResults {
      id value slug numericValue year __typename _schema { label pluralLabel }
      links { id url name label slug __typename }
      supportingIndicatorResults {
        id value slug numericValue year __typename _schema { label pluralLabel }
        indicator {
          id title suffixLabel unit { id name shorthand } 
        }
      }
      entityTotals { entity { id name } total }
      keyValuePairs { key value }
      indicator { 
        id 
        suffixLabel
        unit { id name shorthand } 
        subtitle title
        content { id plain text }
        image { id name image { url } }
        links { id url path name label slug __typename }
      }
    }
    entityType { useAi }
    entityViews {
      id name hash label slug count showCount
      type { id name slug }
      slices {
        id name slug label updated
        title 
        titleRich { id text }
        layout { id name slug component }
        themeMode { id name slug }
        openGraph {
          id
          image { url thumbnails { large { url } bubble { url url2x } } }
        }
        authors {
          id slug name __typename
          position
          organisation { id name }
          openGraph {
            id image { url url2x thumbnails { bubble { url url2x } } }
          }
        }
        restorationProjects {
          __typename id name path slug
          openGraph {
            id title description { id text }
            image {
              id url url2x
            }
          }
          organisation { id name __typename }
          species { id name __typename }
          methodologies { id name __typename }
          reasons { __typename id name }
        }
        headerFontType { internalName }
        bodyFontType { internalName }
        disabled
        connectedEntities { name label internalName }
        entityLayout { internalName }
        link { id url path name label }
        created updated
        outro { id text }
        intro { id text }
        content { 
          id plain text 
          linkEmbeds { 
              id name _label url slug __typename
              image { id url width height }
            } 
          linkRichEmbeds { 
            id name _label url slug __typename
            image { id url width height }
          }
        }
        email
        phone
        twitter
        threads
        linkedin
        backgroundColor { id value }
        backgroundImages { id image { url url2x }  }
        color { id value }
        teams { id name slug __typename _schema { label pluralLabel } }
        objectives { id name slug __typename type { id name slug __typename } }
        icon { id slug name component }
        embeds {
          citations {
            slug url name authors { id name slug } 
            authorShowsEtAl edition publication accessDate 
            startPage volume footnoteNumber year
          }
          posts {
            id name slug path
            openGraph {
              title description { plain(truncate: {words: 20}) }
              image { url url2x type }
            }
          }
          imageAssets {
            id
            slug
            portraitImage { id width height url url2x }
            image { id url url2x width height type }
          }
        }
        people {
          id name slug path __typename
          organisation { id name }
          linkedin
          position
          openGraph { id image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        indicators { 
          id name slug title
        }
        indicatorGroups { 
          id slug name 
        }
        economies {
          id name slug path __typename _schema { label pluralLabel }
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        } 
        videos {
          id name path slug __typename _schema { label pluralLabel } 
          openGraph { id image { url url2x thumbnails { card { url url2x } } } }
        }
        locations { 
          id name slug __typename _schema { label pluralLabel } 
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        }
        posts { 
          id name slug path __typename _schema { label  pluralLabel }
          type { id name slug }
          typeLabel
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        }
        citations {
          slug url name __typename _schema { label pluralLabel }
          authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
        }
        feedEntries {
          name id slug path url __typename _schema { label pluralLabel }
          type { id name slug }
          typeLabel
          openGraph { id title image { url url2x thumbnails { full { url url2x } } } }
          people { id name slug __typename openGraph { id image { id url thumbnails { bubble { url url2x } } } } }
        }
        organisations { 
          id name slug path __typename _schema { label pluralLabel }
          openGraph { id image { url url2x thumbnails { bubble { url url2x } card { url url2x } } } }
        }
      }
    }
  } }
}
`;